import Types from "./Types";

export const getStudentExamsRequest = (search = null) => ({
  type: Types.GET_ADMIN_STUDENT_EXAMS_MAIN_REQUEST,
  payload: search,
});

export const getStudentExamsSuccess = (data) => ({
  type: Types.GET_ADMIN_STUDENT_EXAMS_MAIN_SUCCESS,
  payload: data,
});

export const getStudentExamsFail = () => ({
  type: Types.GET_ADMIN_STUDENT_EXAMS_MAIN_FAIL,
});

export const redoExamRequest = (studentExamId, action) => ({
  type: Types.REDO_EXAM_REQUEST,
  payload: studentExamId,
  action: action,
});

export const redoExamSuccess = (data) => ({
  type: Types.REDO_EXAM_SUCCESS,
  payload: data,
});

export const redoExamFail = () => ({
  type: Types.REDO_EXAM_FAIL,
});

export const addStudentExamsLoading = (isLoading) => ({
  type: Types.ADD_ADMIN_STUDENT_EXAMS_LOADING,
  payload: isLoading,
});

export const getStudentExamsByExamRequest = (examId) => ({
  type: Types.GET_STUDENT_EXAMS_BY_EXAM_REQUEST,
  payload: examId,
});

export const getStudentExamsByExamSuccess = (data) => ({
  type: Types.GET_STUDENT_EXAMS_BY_EXAM_SUCCESS,
  payload: data,
});

export const getStudentExamsByExamFail = () => ({
  type: Types.GET_STUDENT_EXAMS_BY_EXAM_FAIL,
});

export const getCorrectionQuestionsRequest = (studentExamId) => ({
  type: Types.GET_CORRECTION_QUESTIONS_REQUEST,
  payload: studentExamId,
});

export const getCorrectionQuestionsSuccess = (data) => ({
  type: Types.GET_CORRECTION_QUESTIONS_SUCCESS,
  payload: data,
});

export const getCorrectionQuestionsFail = () => ({
  type: Types.GET_CORRECTION_QUESTIONS_FAIL,
});

export const correctStudentExamRequest = (body, action) => ({
  type: Types.CORRECT_STUDENT_EXAM_REQUEST,
  payload: body,
  action,
});

export const correctStudentExamSuccess = (data) => ({
  type: Types.CORRECT_STUDENT_EXAM_SUCCESS,
  payload: data,
});

export const correctStudentExamFail = () => ({
  type: Types.CORRECT_STUDENT_EXAM_FAIL,
});

export const clearCorrectionQuestions = () => ({
  type: Types.CLEAR_CORRECTION_QUESTIONS,
});

export const getCorrectedQuestionsRequest = (studentExamId) => ({
  type: Types.GET_CORRECTED_QUESTIONS_REQUEST,
  payload: studentExamId,
});

export const getCorrectedQuestionsSuccess = (data) => ({
  type: Types.GET_CORRECTED_QUESTIONS_SUCCESS,
  payload: data,
});

export const getCorrectedQuestionsFail = () => ({
  type: Types.GET_CORRECTED_QUESTIONS_FAIL,
});

export const clearCorrectedQuestions = () => ({
  type: Types.CLEAR_CORRECTED_QUESTIONS,
});

